// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signature_signatureContainer__bJOOB {
  padding: 30px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  margin-bottom: 30px;
}
.signature_signatureContainer__bJOOB h2 {
  text-align: center;
  color: #2c3e50;
  font-size: 2rem;
  margin-bottom: 30px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.signature_signatureSection__nCARe {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 20px;
}

.signature_signatureCard__2N9ep {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.signature_signatureCard__2N9ep:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  border-color: #667eea;
}
.signature_signatureCard__2N9ep h3 {
  color: #2c3e50;
  font-size: 1.3rem;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 10px;
}

.signature_signatureContent__iHRSR {
  position: relative;
}

.signature_signaturePreview__H0AAo {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  position: relative;
}
.signature_signaturePreview__H0AAo img {
  max-width: 100%;
  max-height: 120px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  border: 2px solid #e9ecef;
  background: white;
  padding: 5px;
}
.signature_signaturePreview__H0AAo p {
  color: #495057;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  margin: 0;
  word-break: break-word;
  max-width: 100%;
}

.signature_signatureActions__yXs2P {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 15px;
}

.signature_toggleButton__76qdP, .signature_deleteButton__T06XU {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.signature_toggleButton__76qdP {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}
.signature_toggleButton__76qdP:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.signature_deleteButton__T06XU {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
}
.signature_deleteButton__T06XU:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

.signature_uploadSection__rsWcj {
  position: relative;
}

.signature_fileInput__AbtzN {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 2;
}

.signature_uploadButton__NBOWg {
  display: block;
  cursor: pointer;
  width: 100%;
  height: 200px;
  border: 3px dashed #dee2e6;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background: #f8f9fa;
  position: relative;
  overflow: hidden;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  font-weight: 500;
  color: #6c757d;
}
.signature_uploadButton__NBOWg:hover {
  border-color: #667eea;
  background: #f0f4ff;
  transform: scale(1.02);
}

.signature_generateButton__tpmzv {
  margin-top: 15px;
  width: 100%;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.signature_generateButton__tpmzv:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.signature_visible__4CGIJ {
  display: block;
}

.signature_hidden__VjJ5R {
  display: none;
}

.signature_saveSignaturesSection__2UjjU {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  padding: 20px 0;
  border-top: 2px solid #e9ecef;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
}

.signature_saveSignaturesButton__FkAtq {
  padding: 15px 40px;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
}
.signature_saveSignaturesButton__FkAtq:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4);
  background: linear-gradient(135deg, #ff5252, #d63031);
}
.signature_saveSignaturesButton__FkAtq:active {
  transform: translateY(-1px);
}
.signature_saveSignaturesButton__FkAtq:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, #bdc3c7, #95a5a6);
}

@media (max-width: 768px) {
  .signature_signatureContainer__bJOOB {
    padding: 20px;
  }
  .signature_signatureSection__nCARe {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .signature_signatureCard__2N9ep {
    padding: 20px;
  }
  .signature_signatureCard__2N9ep .signature_uploadButton__NBOWg {
    height: 150px;
  }
  .signature_signatureCard__2N9ep .signature_signaturePreview__H0AAo img {
    max-height: 80px;
  }
  .signature_saveSignaturesSection__2UjjU {
    margin: 20px 0;
    padding: 15px 0;
  }
  .signature_saveSignaturesSection__2UjjU .signature_saveSignaturesButton__FkAtq {
    padding: 12px 30px;
    font-size: 16px;
    min-width: 180px;
  }
}
@media (max-width: 480px) {
  .signature_signatureCard__2N9ep .signature_uploadButton__NBOWg {
    height: 120px;
  }
  .signature_signatureCard__2N9ep .signature_signaturePreview__H0AAo img {
    max-height: 60px;
  }
  .signature_signatureCard__2N9ep .signature_signaturePreview__H0AAo p {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/403/signature.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AACJ;;AAGA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,yBAAA;EACA,6BAAA;AAAF;AAEE;EACE,2BAAA;EACA,2CAAA;EACA,qBAAA;AAAJ;AAGE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,oBAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;AAFJ;AAKE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AAHJ;;AAOA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAJF;;AAOA;EACE,qDAAA;EACA,YAAA;AAJF;AAME;EACE,2BAAA;EACA,+CAAA;AAJJ;;AAQA;EACE,qDAAA;EACA,YAAA;AALF;AAOE;EACE,2BAAA;EACA,+CAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AANF;;AASA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;EACA,gBAAA;EACA,cAAA;AANF;AAQE;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAPF;AASE;EACE,2BAAA;EACA,6CAAA;AAPJ;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;EACA,6DAAA;EACA,mBAAA;AATF;;AAYA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,sDAAA;EACA,qDAAA;EACA,YAAA;EACA,+CAAA;EACA,yBAAA;EACA,mBAAA;AATF;AAWE;EACE,2BAAA;EACA,+CAAA;EACA,qDAAA;AATJ;AAYE;EACE,2BAAA;AAVJ;AAaE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,qDAAA;AAXJ;;AAgBA;EACE;IACE,aAAA;EAbF;EAgBA;IACE,0BAAA;IACA,SAAA;EAdF;EAiBA;IACE,aAAA;EAfF;EAiBE;IACE,aAAA;EAfJ;EAkBE;IACE,gBAAA;EAhBJ;EAoBA;IACE,cAAA;IACA,eAAA;EAlBF;EAoBE;IACE,kBAAA;IACA,eAAA;IACA,gBAAA;EAlBJ;AACF;AAsBA;EAEI;IACE,aAAA;EArBJ;EAyBI;IACE,gBAAA;EAvBN;EA0BI;IACE,iBAAA;EAxBN;AACF","sourcesContent":[".signatureContainer {\n  padding: 30px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border-radius: 12px;\n  margin-bottom: 30px;\n\n  h2 {\n    text-align: center;\n    color: #2c3e50;\n    font-size: 2rem;\n    margin-bottom: 30px;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.signatureSection {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 30px;\n  margin-top: 20px;\n}\n\n.signatureCard {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n\n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n    border-color: #667eea;\n  }\n\n  h3 {\n    color: #2c3e50;\n    font-size: 1.3rem;\n    margin-bottom: 20px;\n    text-align: center;\n    font-weight: 600;\n    border-bottom: 2px solid #e9ecef;\n    padding-bottom: 10px;\n  }\n}\n\n.signatureContent {\n  position: relative;\n}\n\n.signaturePreview {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  position: relative;\n\n  img {\n    max-width: 100%;\n    max-height: 120px;\n    object-fit: contain;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    margin-bottom: 10px;\n    border: 2px solid #e9ecef;\n    background: white;\n    padding: 5px;\n  }\n\n  p {\n    color: #495057;\n    font-size: 0.9rem;\n    font-weight: 500;\n    text-align: center;\n    margin: 0;\n    word-break: break-word;\n    max-width: 100%;\n  }\n}\n\n.signatureActions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 15px;\n}\n\n.toggleButton, .deleteButton {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n}\n\n.toggleButton {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  }\n}\n\n.deleteButton {\n  background: linear-gradient(135deg, #ff6b6b, #ee5a24);\n  color: white;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);\n  }\n}\n\n.uploadSection {\n  position: relative;\n}\n\n.fileInput {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.uploadButton {\n  display: block;\n  cursor: pointer;\n  width: 100%;\n  height: 200px;\n  border: 3px dashed #dee2e6;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  background: #f8f9fa;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  font-weight: 500;\n  color: #6c757d;\n\n  &:hover {\n    border-color: #667eea;\n    background: #f0f4ff;\n    transform: scale(1.02);\n  }\n}\n\n.generateButton {\n  margin-top: 15px;\n  width: 100%;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n  }\n}\n\n.visible {\n  display: block;\n}\n\n.hidden {\n  display: none;\n}\n\n// Save Signatures Section\n.saveSignaturesSection {\n  display: flex;\n  justify-content: center;\n  margin: 30px 0;\n  padding: 20px 0;\n  border-top: 2px solid #e9ecef;\n  border-bottom: 2px solid #e9ecef;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 12px;\n}\n\n.saveSignaturesButton {\n  padding: 15px 40px;\n  border: none;\n  border-radius: 30px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 200px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: linear-gradient(135deg, #ff6b6b, #ee5a24);\n  color: white;\n  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.3);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4);\n    background: linear-gradient(135deg, #ff5252, #d63031);\n  }\n\n  &:active {\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n    background: linear-gradient(135deg, #bdc3c7, #95a5a6);\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .signatureContainer {\n    padding: 20px;\n  }\n\n  .signatureSection {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .signatureCard {\n    padding: 20px;\n\n    .uploadButton {\n      height: 150px;\n    }\n\n    .signaturePreview img {\n      max-height: 80px;\n    }\n  }\n\n  .saveSignaturesSection {\n    margin: 20px 0;\n    padding: 15px 0;\n\n    .saveSignaturesButton {\n      padding: 12px 30px;\n      font-size: 16px;\n      min-width: 180px;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .signatureCard {\n    .uploadButton {\n      height: 120px;\n    }\n\n    .signaturePreview {\n      img {\n        max-height: 60px;\n      }\n\n      p {\n        font-size: 0.8rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signatureContainer": `signature_signatureContainer__bJOOB`,
	"signatureSection": `signature_signatureSection__nCARe`,
	"signatureCard": `signature_signatureCard__2N9ep`,
	"signatureContent": `signature_signatureContent__iHRSR`,
	"signaturePreview": `signature_signaturePreview__H0AAo`,
	"signatureActions": `signature_signatureActions__yXs2P`,
	"toggleButton": `signature_toggleButton__76qdP`,
	"deleteButton": `signature_deleteButton__T06XU`,
	"uploadSection": `signature_uploadSection__rsWcj`,
	"fileInput": `signature_fileInput__AbtzN`,
	"uploadButton": `signature_uploadButton__NBOWg`,
	"generateButton": `signature_generateButton__tpmzv`,
	"visible": `signature_visible__4CGIJ`,
	"hidden": `signature_hidden__VjJ5R`,
	"saveSignaturesSection": `signature_saveSignaturesSection__2UjjU`,
	"saveSignaturesButton": `signature_saveSignaturesButton__FkAtq`
};
export default ___CSS_LOADER_EXPORT___;
